const PostingStatus = {
  READY_TO_POST: 'READY_TO_POST',
  POSTING: 'POSTING',
  POSTED: 'POSTED',
  POST_FAILED: 'POST_FAILED',
  _Values: () =>
    Object.keys(PostingStatus)
      .filter(key => typeof PostingStatus[key] !== 'function')
      .map(key => PostingStatus[key]),
};
module.exports = { PostingStatus: PostingStatus };
